import { TableHead, TableHeader, TableRow } from "@/components/ui/table";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import {
  Package,
  TrendingUp,
  DollarSign,
  CheckCircle,
  Calendar,
} from "lucide-react";

export function StockTableHeader() {
  return (
    <TooltipProvider>
      <TableHeader className="bg-gradient-to-r from-slate-50 to-gray-50 border-b">
        <TableRow className="hover:bg-transparent">
          <TableHead className="font-semibold text-slate-700 py-2 px-2 text-sm">
            Variant
          </TableHead>
          <TableHead className="font-semibold text-slate-700 py-2 px-2 text-center text-sm">
            <Tooltip>
              <TooltipTrigger asChild>
                <div className="flex items-center justify-center gap-1 md:gap-1.5 cursor-help">
                  <TrendingUp className="h-3 w-3 md:h-3.5 md:w-3.5 shrink-0" />
                  <span className="text-xs md:text-sm whitespace-nowrap">Stock Movement</span>
                </div>
              </TooltipTrigger>
              <TooltipContent>
                <div className="text-xs space-y-1">
                  <div>
                    Shows inflows (received, adjustments in) and outflows (sold,
                    adjustments out)
                  </div>
                </div>
              </TooltipContent>
            </Tooltip>
          </TableHead>
          <TableHead className="font-semibold text-slate-700 py-2 px-2 text-right text-sm">
            <div className="flex items-center justify-end gap-1 md:gap-1.5">
              <DollarSign className="h-3 w-3 md:h-3.5 md:w-3.5 shrink-0" />
              <span className="text-xs md:text-sm whitespace-nowrap">Price</span>
            </div>
          </TableHead>
          <TableHead className="font-semibold text-slate-700 py-2 px-2 text-center text-sm">
            <div className="flex items-center justify-center gap-1 md:gap-1.5">
              <Calendar className="h-3 w-3 md:h-3.5 md:w-3.5 shrink-0" />
              <span className="text-xs md:text-sm whitespace-nowrap">Date</span>
            </div>
          </TableHead>
          <TableHead className="w-10 md:w-12 py-2 px-1 md:px-2 shrink-0"></TableHead>
        </TableRow>
      </TableHeader>
    </TooltipProvider>
  );
}
